// extracted by mini-css-extract-plugin
module.exports = {"content":"index_content__3p8ER","container":"index_container__3jN6p","btn-forgot":"index_btn-forgot__30li1","divider":"index_divider__1B4Kb","mini-icon":"index_mini-icon__2_CnG"};